import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import * as globalConst from './../../../constants';

@Injectable()
export class ProfileUserService {

  private apiUrl = globalConst.baseAPI;

  constructor(private http: Http) { }


  getUsers(){
    return this.http
			.get(this.apiUrl + "/users/v1/getsimpleuserlist/", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
  }

	getProfileEdit(search) {
		console.log("Search Post",search);

		return this.http
		.post(this.apiUrl + "profilestructure/v1/getprofileedit", search, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json()).catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
  }

  getProfile(){
    return this.http
		.get(this.apiUrl + "profile/v1/getprofiles", JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json()).catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	// populateProfiles(){
	// 	return this.http
	// 		.get(this.apiUrl + "profilestructure/v1/getprofile", JSON.parse(localStorage.getItem('yara.connectionHeader')))
	// 		.map((res: Response) => res.json()).catch(e => {
	// 			if (e.status === 401) {
	// 				return Observable.throw('Unauthorized');
	// 			}
	// 		});
	// 	}

	saveProfile(profile){
		return this.http
		.post(this.apiUrl + "profilestructure/v1/insertupdateprofile", profile, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json()).catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/profile-user/service/profile-user.service.ts